import React from 'react'
import Slick from 'react-slick'

const defaultOptions = {
  arrow: true,
  className: 'carousel',
  dots: true,
  dotsClass: 'carousel-dots',
  infinite: false
}

function Carousel({...props}) {
  const carouselOptions = props.options ? { ...defaultOptions, ...props.options } : defaultOptions

  return (
    <Slick {...carouselOptions}>
      {props.children}
    </Slick>
  );
}

export default Carousel;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Carousel.js